import { ParticipantMember } from '@rolebase/shared/model/member'
import { Alert, AlertDescription, AlertIcon } from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
  voters: ParticipantMember[]
}

// Says which participants cannot vote for lack of an account (D6).
//
// They are excluded from the tally, and that part is not a defect: someone who
// cannot log in cannot vote, and counting them would block every proposal
// forever. The defect was the silence — a decision could be taken "by the
// circle's consent" while engaging one person, with nothing saying so. On
// Yocoop's production org, 20 of 21 members have no account.
//
// Names them rather than counting them, because a name is what lets you act:
// invite them, or take the tension to a meeting instead.
export default function ProposalNonVotersNotice({ voters }: Props) {
  const { t } = useTranslation()

  const withoutAccount = useMemo(
    () => voters.filter((voter) => !voter.member.userId),
    [voters]
  )

  if (withoutAccount.length === 0) return null

  return (
    <Alert status="warning" mb={3}>
      <AlertIcon />
      <AlertDescription>
        {t('ProposalNonVotersNotice.text', {
          count: withoutAccount.length,
          total: voters.length,
          members: withoutAccount.map((voter) => voter.member.name).join(', '),
        })}
      </AlertDescription>
    </Alert>
  )
}
